import React from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

interface CellActionProps {
  data?: any;
  onView?: string | ((data: any) => void);
  onEdit?: string | (() => void | string);
  onDelete: (data: any) => void;
}

const CellActions: React.FC<CellActionProps> = ({
  data,
  onView,
  onEdit,
  onDelete,
}) => {
  return (
    <ul className="list-unstyled hstack gap-1 mb-0">
      {onView && (
        <li id="viewtooltip">
          <Link
            onClick={() => (typeof onView === "string" ? {} : onView(data))}
            to={typeof onView === "string" ? onView : "#"}
            className="btn btn-sm btn-soft-primary"
          >
            <i className="mdi mdi-eye-outline"></i>
            <UncontrolledTooltip placement="top" target="viewtooltip">
              View
            </UncontrolledTooltip>
          </Link>
        </li>
      )}

      {onEdit && (
        <li id="edittooltip">
          <Link
            to={typeof onEdit === "string" ? onEdit : "#"}
            className="btn btn-sm btn-soft-info"
            onClick={() => {
              if (typeof onEdit === "function") {
                onEdit();
              }
            }}
          >
            <i className="mdi mdi-pencil-outline" />
            <UncontrolledTooltip placement="top" target="edittooltip">
              Edit
            </UncontrolledTooltip>
          </Link>
        </li>
      )}

      <li id="deleteTooltip">
        <Link
          to="#"
          className="btn btn-sm btn-soft-danger"
          onClick={() => onDelete(data)}
        >
          <i className="mdi mdi-delete" />
          <UncontrolledTooltip placement="top" target="deleteTooltip">
            Delete
          </UncontrolledTooltip>
        </Link>
      </li>
    </ul>
  );
};

export default CellActions;
